import { useMemo, useState } from "react";
import { Button } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/24/solid";
import ModalFrame from "../../../components/ModalFrame";
import Tabs, { SubTab } from "../../../components/Tabs";
import AddDistrictForm from "../../districts/addEdit/add/AddDistrictForm";
import AddExistingDistrictToUser from "../../districts/AddExistingDistrictToUserForm";

export enum AddDistrictSubTabs {
	Existing = "Existing District",
	New = "New District",
}

interface AddDistrictProps {
	userId: number;
	districtIds: number[];
}

export default function AddDistrictToUserButton(props: AddDistrictProps) {
	const [isFormOpen, setIsFormOpen] = useState(false);
	const [hasAutoSwitched, setHasAutoSwitched] = useState(false);
	const [currentTabName, setCurrentTabName] = useState(AddDistrictSubTabs.Existing);

	const initialSubTabs: SubTab[] = useMemo(
		() => [
			{
				name: AddDistrictSubTabs.Existing,
				current: currentTabName === AddDistrictSubTabs.Existing,
				content: (
					<AddExistingDistrictToUser
						userId={props.userId}
						districtIds={props.districtIds}
						onClose={handleCloseForm}
						onSwitchToNewTab={!hasAutoSwitched ? handleAutoSwitchTabs : undefined}
					/>
				),
			},
			{
				name: AddDistrictSubTabs.New,
				current: currentTabName === AddDistrictSubTabs.New,
				content: (
					<AddDistrictForm
						userIdToAdd={props.userId}
						saveButtonText="Add District"
						onClose={handleCloseForm}
					/>
				),
			},
		],
		[props, currentTabName, hasAutoSwitched]
	);

	function handleOpenForm() {
		setIsFormOpen(true);
		setCurrentTabName(AddDistrictSubTabs.Existing);
		setHasAutoSwitched(false);
	}

	function handleCloseForm() {
		setIsFormOpen(false);
	}

	function handleAutoSwitchTabs() {
		setHasAutoSwitched(true);
		setCurrentTabName(AddDistrictSubTabs.New);
	}

	return (
		<>
			<Button id="add-district-button" onClick={handleOpenForm} className="btn btn-primary">
				<span className="flex items-center">
					<PlusIcon className="size-4 mr-2" /> Add
				</span>
			</Button>

			<ModalFrame
				open={isFormOpen}
				title="Add User To District"
				onClose={handleCloseForm}
				maxWidth="max-w-[750px]"
				overflow="overflow-visible">
				<Tabs
					initialSubTabs={initialSubTabs}
					ariaLabel="Add User To District Tabs"
					containerClass="mt-1.5"
					tabPadding="p-2"
					forceActiveTabName={hasAutoSwitched ? currentTabName : undefined}
				/>
			</ModalFrame>
		</>
	);
}
